module.exports = __webpack_public_path__ + "static/Fabrice.5fd28fca.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/team/Fabrice.jpeg
// module id = 935
// module chunks = 3